import { pipe } from 'rxjs';
import { RootState } from './index';

export const selectGame = (state: RootState) => state.game;

export const selectGameStarted = pipe(
  selectGame,
  (game) => game.common.started,
);
